import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionLabel } from "@/components/primitives";
import { clients } from "@/data/content";

// Premium client-name wall. Text only — no logos, results, or partnership claims.
export default function ClientsSection({ withHeader = true }) {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="border-t border-fs-border bg-fs-bg py-24 lg:py-32"
    >
      <div className="fs-shell">
        {withHeader && (
          <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
            <div className="lg:col-span-7">
              <Reveal>
                <SectionLabel testId="clients-label">Selected Clients</SectionLabel>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-6 fs-h2">Businesses we have supported.</h2>
              </Reveal>
            </div>
            <div className="lg:col-span-5">
              <Reveal delay={0.15}>
                <p className="fs-body">
                  Fortuna Strive has worked with businesses across consulting,
                  education, home services, local services, technology, and
                  hospitality.
                </p>
              </Reveal>
            </div>
          </div>
        )}

        <StaggerGroup
          className="mt-16 grid gap-px border border-fs-border bg-fs-border sm:grid-cols-2 lg:grid-cols-4"
          stagger={0.06}
        >
          {clients.map((client) => (
            <StaggerItem key={client.name}>
              <div
                data-testid={`client-${client.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className="group flex h-full min-h-[132px] flex-col justify-between bg-fs-bg p-7 transition-colors duration-300 hover:bg-fs-card"
              >
                <h3 className="font-serif text-xl leading-snug text-fs-ink transition-colors duration-300 group-hover:text-fs-gold">
                  {client.name}
                </h3>
                {client.label && (
                  <span className="mt-5 text-[11px] uppercase tracking-[0.22em] text-fs-muted/60">
                    {client.label}
                  </span>
                )}
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <Reveal delay={0.1}>
          <p
            className="mt-8 max-w-3xl text-xs leading-relaxed text-fs-muted/70"
            data-testid="clients-disclaimer"
          >
            Client names are displayed to represent businesses Fortuna Strive has
            supported. No endorsement or performance claim is implied.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
